





































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiPartenaire from '@/api/partenaire'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import CheckState from '@/components/shared/CheckState.vue'
import { toSubArray } from '@/utils/groupBy'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'
import { getDefaultAloDataSource } from '@/models/alo/AloDataSource'
import * as rules from '@/utils/validationRules'
//@ts-ignore
import VJsoneditor from 'v-jsoneditor/src/index'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'ModifyDataSources', 
  props: {
    dsoId:Number
  },
  components: { CheckState,VJsoneditor},
})

export default class ModifyDataSources extends Vue {
  dsoId!: number
  private showError = false    
  private loading = false
  private saving = false
  private modified = getDefaultAloDataSource()

  get dataSource(){
    return this.$store.myGetters.dataSources[this.dsoId] || getDefaultAloDataSource()
  }

  get json(){
    return JSON.parse(this.modified.dsoParamJson)
  }

  set json(newValue){
    this.modified.dsoParamJson = JSON.stringify(newValue)
  }

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  loadDataSource() {       
    if(this.dsoId != 0) {
      this.loading = true
      this.$store.myActions.ADM_DATASOURCE_DETAIL_REQUEST(this.dsoId).then((dataSource) =>{
        this.modified = {...getDefaultAloDataSource(), ...cloneDeep(dataSource)}
      })
      .finally(() => {        
        this.loading = false
      })    
    }    
  }

  get isDirty() {
    return !deepEqual(this.dataSource,this.modified)
  }

  created(){
    this.loadDataSource()
  }

  get arianeItems() {
    const arianeItems =  [
        {
          text: 'Data sources',
          disabled: false,          
          to: "/admin/datasources",
          exact:true
        }
      ]
    if(this.dataSource) {
        arianeItems.push({
          text: this.dataSource.libelle,
          disabled: true,          
          to: "",
          exact:true
        })
    }
    return arianeItems;
  } 

  get dataSourcesStatus() {
    return this.$store.myGetters.dataSourcesStatus        
  }
  

  saveData() {
    if ((this.$refs.editDataSourceForm as HTMLFormElement).validate()) {
      this.saving = true 
      const redirect = this.modified.id != this.modified.newId
      this.$store.myActions.ADM_DATASOURCE_SAVE_REQUEST(this.modified).then((savedSataSource:any) => {
        this.modified = cloneDeep(savedSataSource)
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.dataSourcesStatus)                  
        if(redirect) this.$router.push({name:'ModifyDataSources',params:{dsoId:savedSataSource.id}})        
      }).finally(()=> {
        this.saving = false
      })    
    }
  }

  deleteDataSource(){
    if(this.dsoId != 0) {      
       this.$confirm("Voulez vous vraiment supprimer ce datasource?",{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_DATASOURCE_DELETE_REQUEST(this.dsoId).then(() => {
            this.$router.push({name:'DataSources'})
          })
        } 
      })          
    } 
  }

  cancelDataSource(){
    if(this.dsoId == 0) this.modified = getDefaultAloDataSource()
    else this.loadDataSource()
  }

}
